export const STEP_LOCATION = 0;
export const STEP_AREA = 1;
export const STEP_CATEGORY = 2;
export const STEP_DETAILS = 3;
